import { getSelectedCoordinates, coordinateToBoundingBox } from 'src/utils/coordinate';

module.exports = _.extend({
  initialize: function () {
    _.bindAll(this, 'handle', '_calculatePageNoOverlap');
    const tool = INKIVE.Tool.getInstance();

    this.editor = tool.editor;
    this.canvas = this.editor.canvas;
    this.svgroot = $('#svgroot').get(0);
  },

  new_coords: {
    center: function (mainBB, bb) {
      return {
        x: (mainBB.x + mainBB.width / 2) - (bb.x + bb.width / 2),
        y: (mainBB.y + mainBB.height / 2) - (bb.y + bb.height / 2)
      };
    },

    vertical_middle: function (mainBB, bb) {
      return {
        x: 0,
        y: (mainBB.y + mainBB.height / 2) - (bb.y + bb.height / 2)
      };
    },

    horizontal_middle: function (mainBB, bb) {
      return {
        x: (mainBB.x + mainBB.width / 2) - (bb.x + bb.width / 2),
        y: 0
      };
    },

    left: function (mainBB, bb) {
      return {
        x: mainBB.x - bb.x,
        y: 0
      };
    },

    right: function (mainBB, bb) {
      return {
        x: (mainBB.x + mainBB.width) - (bb.x + bb.width),
        y: 0
      };
    },

    top: function (mainBB, bb) {
      return {
        x: 0,
        y: mainBB.y - bb.y
      };
    },

    bottom: function (mainBB, bb) {
      return {
        x: 0,
        y: (mainBB.y + mainBB.height) - (bb.y + bb.height)
      };
    }
  },

  handle: function (params) {
    this.elems = _.clone(INKIVE.EditorFacade.getOrderedSelection());
    if (!this.elems || !this.elems.length) return;

    this.position = params.position;
    this.relativeTo = params.relative_to;
    this.offset = params.offset;

    if (isNaN(this.offset) || typeof this.offset !== 'number') {
      this.offset = 0.05;
    }

    this._align();

    this.canvas.runExtensions('clear', {});
    this.trigger();
    this.trigger('end', { element_id: this.elems[0].id });
  },

  _align: function () {
    let mainBB;

    if (_.contains(['selection', 'first_selected', 'last_selected'], this.relativeTo)) {
      mainBB = this._getReferenceElement();
    } else {
      mainBB = svgedit.utilities.getBBox($('#canvasBackground').get(0));

      let offset = 0;

      if (_.contains(['left', 'right'], this.position)) {
        offset = mainBB.width * this.offset;
      } else if (_.contains(['top', 'bottom'], this.position)) {
        offset = mainBB.height * this.offset;
      }

      mainBB.x += offset;
      mainBB.y += offset;
      mainBB.width -= offset * 2;
      mainBB.height -= offset * 2;
    }

    for (let i = 0; i < this.elems.length; i++) {
      const coords = this.new_coords[this.position](mainBB, this._getBBox(this.elems[i]));

      this.relativeTo === 'page_not_overlap' && this._calculatePageNoOverlap(coords, i);
      this._setPosition(this.elems[i], coords);
    }
  },

  _getBBox: function (selected) {
    const zoom = this.canvas.getZoom();
    const coords = INKIVE.Helpers.getSelectedCoordinates(selected);
    const minX = Math.min(coords.x1, coords.x2, coords.x3, coords.x4);
    const minY = Math.min(coords.y1, coords.y2, coords.y3, coords.y4);
    const maxX = Math.max(coords.x1, coords.x2, coords.x3, coords.x4);
    const maxY = Math.max(coords.y1, coords.y2, coords.y3, coords.y4);

    return {
      x: minX / zoom,
      y: minY / zoom,
      width: (maxX - minX) / zoom,
      height: (maxY - minY) / zoom
    };
  },

  _scaleBBox: function (bbox) {
    const zoom = this.canvas.getZoom();

    return {
      x: bbox.x / zoom,
      y: bbox.y / zoom,
      width: bbox.width / zoom,
      height: bbox.height / zoom
    };
  },

  _setPosition: function (elem, coords) {
    const xform = this.svgroot.createSVGTransform();
    const tlist = svgedit.transformlist.getTransformList(elem);

    xform.setTranslate(coords.x, coords.y);
    tlist.appendItem(xform);

    svgedit.recalculate.recalculateDimensions(elem);
    this.canvas.selectorManager.requestSelector(elem).resize();
  },

  _calculatePageNoOverlap: function (coords, index) {
    let i = index;
    let xModifier = 0;
    let yModifier = 0;
    while (i !== 0) {
      i--;
      switch (this.position) {
        case 'left':
          xModifier += this.elems[i].getBBox().width;
          break;
        case 'right':
          xModifier -= this.elems[i].getBBox().width;
          break;
        case 'top':
          yModifier += this.elems[i].getBBox().height;
          break;
        case 'bottom':
          yModifier -= this.elems[i].getBBox().height;
          break;
      }
    }

    coords.x += xModifier;
    coords.y += yModifier;
  },

  _getReferenceElement: function () {
    let reference = this.relativeTo === 'last_selected' ? this.elems.length - 1 : 0;

    this.relativeTo === 'selection' && _.each(this.elems, _.bind(function (elem, index) {
      switch (this.position) {
        case 'left':
          if (elem.getBBox().x < this.elems[reference].getBBox().x) {
            reference = index;
          }
          break;
        case 'right':
          if (elem.getBBox().x + elem.getBBox().width >
            this.elems[reference].getBBox().x + this.elems[reference].getBBox().width) {
            reference = index;
          }
          break;
        case 'top':
          if (elem.getBBox().y < this.elems[reference].getBBox().y) {
            reference = index;
          }
          break;
        case 'bottom':
          if (elem.getBBox().y + elem.getBBox().height >
            this.elems[reference].getBBox().y + this.elems[reference].getBBox().height) {
            reference = index;
          }
          break;
      }
    }, this));

    return this.relativeTo === 'selection' && this.position.includes('middle')
      ? this._scaleBBox(coordinateToBoundingBox(getSelectedCoordinates(this.elems)))
      : this._getBBox(this.elems[reference]);
  }
}, Backbone.Events);
